<template>
  <div class="OwnerAppadvertisingadd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump">{{$t('lang.lab_OwnerBack')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon" class="form">
        <el-form-item :label="$t('lang.lab_community')" prop="gardenId">
          <el-select v-if="this.id" class="single-select" v-model="ruleForm.gardenId"
            :placeholder="$t('lang.lab_selectCommunity')" collapse-tags>
            <el-option v-for="(item, index)  in garden" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-else class="multiple-select" v-model="ruleForm.gardenIds"
            :placeholder="$t('lang.lab_selectCommunity')" collapse-tags multiple filterable clearable @change="change">
            <el-option :key=0 :label="$t('lang.lab_allVillage')" :value=0></el-option>
            <el-option v-for="item in gardens" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_OwnerFl')" prop="category">
          <el-select v-model="ruleForm.category" placeholder>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="this.ruleForm.category=='1'?true:false" :label="$t('lang.lab_typeName2')"
          prop="secCategory">
          <el-select class="inputWidth" v-model="ruleForm.secCategory">
            <el-option v-for="item in optionsSecCategory" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_OwnerName')" prop="name">
          <el-input maxlength="20" style="width:30%" class="select" v-model="ruleForm.name"
            :placeholder="$t('lang.lab_OwnerWriteName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="imageUri" ref="imageUri">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileList" :clears="clears"
            @outputFile="getFile" @removeFile="removeFile"></upload-file>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_OwnerAround')" prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="1">{{$t('lang.lab_OwnerInner')}}</el-radio>
            <el-radio label="2">{{$t('lang.lab_OwnerWnner')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="this.ruleForm.type=='1'?true:false" :label="$t('lang.ownerApp.insideText')" prop="content">
          <!-- 富文本 -->
          <quill-editor v-model="ruleForm.content" ref="myQuillEditor" :options="editorOption" class="text"
            @change="onEditorChange($event)"></quill-editor>
          <span class="editorText"
            v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
          <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
        </el-form-item>
        <el-form-item v-if="this.ruleForm.type=='2'?true:false" :label="$t('lang.lab_OwnerWnnerUrl')" prop="url">
          <el-input style="width:50%" class="select" v-model="ruleForm.url"
            :placeholder="$t('lang.lab_OwnerWnnerUrlTips')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_OwnerBeginDate')" prop="beginTime">
          <el-date-picker class="select" v-model="ruleForm.beginTime" type="date" value-format="timestamp"
            :placeholder="$t('lang.lab_AdverSelectBeginDate')"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_OwnerEndDate')" prop="endTime">
          <el-date-picker class="select" v-model="ruleForm.endTime" type="date" value-format="timestamp"
            :placeholder="$t('lang.lab_AdverSelectBeginDate')"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverSort')" prop="orderBy">
          <el-input-number :placeholder="$t('lang.lab_AdverSortText')" class="select"
            :label="$t('lang.lab_AdverSortText')" v-model="ruleForm.orderBy" controls-position="right"
            @change="handleChange" :min="1" :max="99"></el-input-number>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isCanUse" @click="onSubmit('ruleForm')">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:OwnerAppadvertisingadd
   *@Description:业主端app广告管理添加编辑
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-04-08
   */
  import UploadFile from '../../../components/upload_file.vue'
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      // eslint-disable-next-line
      // var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      var reg = /[a-zA-Z]+:\/\/[^\s]*/
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback()
          // callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
        } else if (value.length > 512) {
          callback(new Error(this.$i18n.t('lang.lab_BigLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
      }
      return {
        clears: false, // 清空按钮
        accept: '.jpg, .jpeg, .png',
        isLength: 0,
        isCanUse: true, // 保存按钮可用状态
        changeIt: '', // 添加是1   编辑是0
        fileList: [], // 文件列表
        id: '', // 广告id
        rules: {
          name: [{
            required: true,
            message: this.$i18n.t('lang.lab_OwnerWriteName'),
            trigger: 'blur'
          }],
          orderBy: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverPleaseSort'),
            trigger: 'blur'
          }],
          imageUri: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
            trigger: 'change'
          }],
          url: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }, {
            required: true,
            message: this.$i18n.t('lang.lab_pleaseWriteOutText'),
            trigger: 'change'
          }],
          type: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseSelectLinkType'),
            trigger: 'change'
          }],
          content: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseWriteInsideText'),
            trigger: 'change'
          }],
        },
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'], // 引用，代码块
              [{
                  header: 1
                },
                {
                  header: 2
                }
              ], // 标题，键值对的形式；1、2表示字体大小
              [{
                  list: 'ordered'
                },
                {
                  list: 'bullet'
                }
              ], // 列表
              [{
                  script: 'sub'
                },
                {
                  script: 'super'
                }
              ], // 上下标
              [{
                  indent: '-1'
                },
                {
                  indent: '+1'
                }
              ], // 缩进
              [{
                direction: 'rtl'
              }], // 文本方向
              [{
                size: ['small', false, 'large', 'huge']
              }], // 字体大小
              [{
                header: [1, 2, 3, 4, 5, 6, false]
              }], // 几级标题
              [{
                  color: []
                },
                {
                  background: []
                }
              ], // 字体颜色，字体背景颜色
              [{
                font: []
              }], // 字体
              [{
                align: []
              }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image', 'video'] // 上传图片、上传视频
            ]
          },
          theme: 'snow',
          placeholder: this.$i18n.t('lang.lab_text')
        },
        saveData: '',
        tableData: [], // 小区列表
        ruleForm: {
          gardenId: this.$store.getters.gardenId,
          gardenIds: [],
          name: '', // 名称
          url: '', // 外链内容
          content: '', // 内链内容
          imageUri: '', // 图片链接
          type: '', // 内链还是外链
          category: 1, // 分类
          beginTime: '', // 开始时间
          endTime: '', // 结束时间
          orderBy: '1', // 排序方式
          secCategory: '' // 二级分类
        },
        oldsearchUnit: [],
        // gardens: [], // 小区集合
        garden: [], // 所选小区
        options: this.$i18n.t('lang.options'),
        optionsSecCategory: this.$i18n.t('lang.optionsSecCategory'),
        detail: this.$i18n.t('lang.ownerApp')
      }
    },
    components: {
      'upload-file': UploadFile
    },
    destroyed() {
      window.localStorage.setItem('yzappform', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('yzappsaveData', JSON.stringify(this.saveData))
    },
    created() {
      if (window.localStorage.getItem('yzappform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('yzappform'))
        if (this.ruleForm.imageUri) {
          this.fileList.push({
            name: '',
            url: this.ruleForm.imageUri
          })
        }
        if (window.localStorage.getItem('yzappsaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('yzappsaveData'))
        }
      } else {
        this.ruleForm.gardenId = this.$store.getters.gardenId
        this.fileList = []
        // 获取广告id 有id是编辑  没有id是添加
        this.id = this.$route.query.id
        if (this.id) {
          // 编辑
          this.changeIt = 0
          this.myGarden()
          // 获取详情数据
          this.$get(`/doorDeviceNoticeById/` + this.id).then(
            res => {
              if (res) {
                this.ruleForm = res.doorDeviceNotice
                this.ruleForm.gardenId = this.ruleForm.gardenId
                this.ruleForm.name = this.ruleForm.name.toString()
                this.ruleForm.url = this.ruleForm.url.toString()
                this.ruleForm.content = this.ruleForm.content.toString()
                this.ruleForm.type = this.ruleForm.type.toString()
                this.ruleForm.category = this.ruleForm.category
                this.ruleForm.secCategory = this.ruleForm.secCategory
                this.ruleForm.orderBy = this.ruleForm.orderBy
                this.ruleForm.imageUri = this.ruleForm.image
                if (this.ruleForm.imageUri) {
                  this.fileList.push({
                    name: '',
                    url: this.ruleForm.imageUri
                  })
                } else {
                  this.fileList = []
                }
                this.ruleForm.beginTime = this.ruleForm.beginTime
                this.ruleForm.endTime = this.ruleForm.endTime
                // 将开始时间 结束时间转化为时间戳
                let d = new Date(this.ruleForm.beginTime)
                let dd = new Date(this.ruleForm.endTime)
                let beginTime = d.getTime(d)
                let endTime = dd.getTime(dd)
                this.ruleForm.beginTime = beginTime
                this.ruleForm.endTime = endTime
                this.saveData = JSON.stringify(this.ruleForm)
                this.isLength = this.ruleForm.content.replace(/[\u0391-\uFFE5]/g, 'a').length - 7
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          this.fileList = []
          // 添加
          this.changeIt = 1
          // this.selectGarden()
        }
      }
    },
    computed: {
      ...mapGetters({
        gardens: 'userGardenList'
      })
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule == this.saveData) {
            // 没变
            this.isCanUse = true
          } else {
            // 变了
            this.isCanUse = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 获取组件值
      getFile(e) {
        this.ruleForm.imageUri = e
        this.$refs.imageUri.clearValidate()
      },
      // 移除图片
      removeFile(e) {
        this.fileList = []
        this.ruleForm.imageUri = ''
      },
      handleChange(value) {
        console.log(value)
      },
      // 内容字数提示
      onEditorChange(event) {
        event.quill.deleteText(10000, 4)
        if (this.ruleForm.content == '') {
          this.isLength = 0
        } else {
          this.isLength = event.quill.getLength() - 1
        }
      },
      // 小区下拉
      myGarden() {
        let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.garden = myGardens
      },
      // 小区下拉
      // selectGarden() {
      //   this.$get(`/gardens`).then(
      //     res => {
      //       if (res && res.errCode === 0) {
      //         this.gardens = res.list
      //       }
      //     },
      //     error => {
      //       this.$message.error(error)
      //     }
      //   )
      // },
      changeFl(val) {
        this.ruleForm.secCategory = ''
      },
      // 多选项
      change(val) {
        const allValues = []
        // 将全选"0"加入allValues
        allValues.push(0)
        for (const item of this.gardens) {
          allValues.push(item.id)
        }
        // 用来储存上一次选择的值，可进行对比
        const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
        // 若选择全部
        if (val.includes(0)) {
          this.ruleForm.gardenIds = allValues
        }
        // 取消全部选中， 上次有， 当前没有， 表示取消全选
        if (oldVal.includes(0) && !val.includes(0)) {
          this.ruleForm.gardenIds = []
        }
        // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
        if (oldVal.includes(0) && val.includes(0)) {
          const index = val.indexOf(0)
          val.splice(index, 1)
          this.ruleForm.gardenIds = val
        }
        // 全选未选，但是其他选项都全部选上了，则全选选上
        if (!oldVal.includes(0) && !val.includes(0)) {
          if (val.length === allValues.length - 1) {
            this.ruleForm.gardenIds = [0].concat(val)
          }
        }
        // 储存当前选择的最后结果 作为下次的老数据
        this.oldsearchUnit[0] = this.ruleForm.gardenIds
      },
      // 跳转到业主App广告管理
      jump() {
        this.$router.push({
          name: 'OwnerAppadvertisingList'
        })
      },
      // 保存方法
      onSubmit(formName) {
        if (this.ruleForm.endTime < this.ruleForm.beginTime) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('lang.lab_AdverTimeTips')
          })
          return
        }
        // 添加
        if (this.changeIt == 1) {
          // 杜，添加向后台传的参数
          let params = {
            'garden[]': this.ruleForm.gardenIds.toString(),
            name: this.ruleForm.name,
            image: this.ruleForm.imageUri,
            content: this.ruleForm.type == 1 ? this.ruleForm.content : '',
            type: this.ruleForm.type,
            url: this.ruleForm.type == 2 ? this.ruleForm.url : '',
            orderBy: this.ruleForm.orderBy,
            category: this.ruleForm.category,
            beginDate: this.ruleForm.beginTime,
            endDate: this.ruleForm.endTime,
            secCategory: this.ruleForm.secCategory
          }
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.$post('/doorDeviceNotice', params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.eagleEye.addSucceed')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.doorDeviceNoticeList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'OwnerAppadvertisingList'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        } else if (this.changeIt == 0) {
          // 编辑
          let params = {
            shareFlag: this.ruleForm.gardenId,
            name: this.ruleForm.name,
            image: this.ruleForm.imageUri,
            content: this.ruleForm.type == 1 ? this.ruleForm.content : '',
            type: this.ruleForm.type,
            url: this.ruleForm.type == 2 ? this.ruleForm.url : '',
            orderBy: this.ruleForm.orderBy.toString(),
            category: this.ruleForm.category,
            beginDate: this.ruleForm.beginTime,
            endDate: this.ruleForm.endTime
          }
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.$patch(`/doorDeviceNotice/${this.id}`, params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_modify_success')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.doorDeviceNoticeList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'OwnerAppadvertisingList'
                  })
                  this.pageCount = 1
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        }
      },
      resetForm(formName) {
        this.fileList = []
        this.clears = true
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.gardenId = ''
        this.ruleForm.category = 1
        this.ruleForm.name = ''
        this.ruleForm.imageUri = ''
        this.ruleForm.type = ''
        this.ruleForm.beginTime = ''
        this.ruleForm.endTime = ''
        this.ruleForm.orderBy = '1'
        this.ruleForm.content = ''
        this.ruleForm.url = ''
        this.ruleForm.image = ''
        this.isLength = 0
      }
    }
  }
</script>

<style lang="scss">
</style>